/**
 * Contains the list of supported providers.
 */
const MS_PROVIDERS = ['planner', 'outlook', 'lumapps'];
const GOOGLE_PROVIDERS = ['lumapps'];

export { GOOGLE_PROVIDERS, MS_PROVIDERS };
